// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;For you are the God of my refuge;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;why have you cast me from you,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and why go I so heavily, while the enemy oppresses me?<br> </p> </div></div>";
// Exports
module.exports = code;